import { DataConnectionService } from "../v2/services";

// Keep this file here because many components are using it from this path
// Those components should import it from the v2/services path or even better:
// shouldn't be using the graphql client directly
export const client = DataConnectionService.graphqlApolloClient;
export const client3 = DataConnectionService.graphqlApolloClient3;
